/**
 * Photo URLs can come back as http:// (e.g. the staging bucket's). An https page
 * can't fetch those — mixed content is blocked outright, unlike an <img> — and
 * the storage serves the same files over https, so the scheme is upgraded there.
 * An http page keeps the URL as it is.
 */
export const matchPageScheme = (url: string, pageProtocol = window.location.protocol) =>
  pageProtocol === "https:" ? url.replace(/^http:\/\//i, "https://") : url;
